/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_H1Inputs */

const en_guides_h1 = /** @type {(inputs: Guides_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Guides & Tutorials`)
};

const ko_guides_h1 = /** @type {(inputs: Guides_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 가이드 & 튜토리얼`)
};

const ja_guides_h1 = /** @type {(inputs: Guides_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONガイド＆チュートリアル`)
};

/**
* | output |
* | --- |
* | "JSON Guides & Tutorials" |
*
* @param {Guides_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_h1 = /** @type {((inputs?: Guides_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_h1(inputs)
	if (locale === "ko") return ko_guides_h1(inputs)
	return ja_guides_h1(inputs)
});